<template>
  <div>
    <transition name="el-fade-in-linear">
      <table class="table" v-if="productSuppliers.length">
        <thead>
          <tr>
            <th>Lieferant</th>
            <th>Artikelnr</th>
            <th class="text-center">Preis (netto)</th>
            <th class="text-center">Datum</th>
            <th class="text-center">Bestellen</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="supplier in productSuppliers" :key="supplier.id">
            <td>
              <router-link :to="`/suppliers/${supplier.supplier.id}`"
              >
                {{ supplier.supplier.name }}
              </router-link>
            </td>
            <td>{{ supplier.referenznummer }}</td>
            <td class="text-right">
              <a v-if="supplier.price !== 0" href="#" @click.prevent="editPrice(supplier.supplier.id)"> {{ supplier.price | priceFromCentEuro }}</a>
              <a v-else href="#" @click.prevent="editPrice(supplier.supplier.id)"> {{ supplier.price.toFixed(2).replace('.', ',') }} €</a>
            </td>
            <td class="text-right">{{ supplier.created_at | date }}</td>
            <td class="text-center">
              <router-link :to="`/orders/create?product=${supplier.product_id}&supplier=${supplier.supplier_id}`"
                v-tooltip.top-center="'Produkt bestellen'" class="btn btn-warning btn-link btn-xs"
              >
                <i class="fas fa-shopping-cart"></i>
              </router-link>
            </td>
            <td class="text-right">
              <div class="td-actions">
                <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                  @click="$emit('editProductSupplier', supplier)"
                  v-if="showEdit"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                   @click="$emit('deleteProductSupplier', supplier)">
                  <i class="fa fa-close"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </transition>
    <p v-if="! productSuppliers.length">Keine Lieferanten zugewiesen</p>
    <product-price-dialog
      :show="showEditPrice"
      @close="showEditPrice = false"
      @updatePrice="updatePrice"
      :val-errors="[]"
    />
  </div>
</template>

<script>
import { groupNewestSuppliers } from 'src/util/helpers'
import ProductPriceDialog from 'src/pages/Suppliers/Products/product-price-dialog'

export default {
  props: {
    suppliers: null,
    product: null,
    showEdit: {
      default: false
    }
  },
  components: { ProductPriceDialog },
  data () {
    return {
      showEditPrice: false,
      selectedSupplier: null
    }
  },
  methods: {
    editPrice (supplier) {
      this.selectedSupplier = supplier
      this.showEditPrice = true
    },
    // DRY
    async updatePrice (price) {
      await this.initCsrf()
      const referenznummer = this.productSuppliers[0].referenznummer;

      const url = `/products/${this.product.id}/suppliers/${this.selectedSupplier}`
      this.$http.post(url, { price, referenznummer }).then(({ data }) => {
        this.$notify({
          message: 'Preis erfolgreich aktualisiert.',
          type: 'success'
        })
        this.$emit('bla', data)
        this.selectedSupplier = null
        this.showEditPrice = false
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    }
  },
  computed: {
    productSuppliers () {
      return groupNewestSuppliers(this.suppliers)
    }
  }
}
</script>

<style>
</style>
